const Lato_700Bold = { fontFamily: 'Lato-Bold' };
const Lato_400Regular = { fontFamily: 'Lato-Regular' };

// Aliases (pointing LeagueSpartan variables to Lato fonts)
const LeagueSpartan_700Bold = Lato_700Bold;
const LeagueSpartan_300Light = Lato_400Regular; // closest substitute
const LeagueSpartan_500Medium = Lato_400Regular;
const LeagueSpartan_400Regular = Lato_400Regular;
const LeagueSpartan_600SemiBold = Lato_700Bold;

export const fonts = {
  Lato_700Bold,
  Lato_400Regular,
  LeagueSpartan_700Bold,
  LeagueSpartan_300Light,
  LeagueSpartan_500Medium,
  LeagueSpartan_400Regular,
  LeagueSpartan_600SemiBold,
};


// const Lato_700Bold = { fontFamily: 'Lato-Bold' };
// const Lato_400Regular = { fontFamily: 'Lato-Regular' };

// const LeagueSpartan_700Bold = { fontFamily: 'LeagueSpartan-Bold' };
// const LeagueSpartan_300Light = { fontFamily: 'LeagueSpartan-Light' };
// const LeagueSpartan_500Medium = { fontFamily: 'LeagueSpartan-Medium' };
// const LeagueSpartan_400Regular = { fontFamily: 'LeagueSpartan-Regular' };
// const LeagueSpartan_600SemiBold = { fontFamily: 'LeagueSpartan-SemiBold' };

// export const fonts = {
//   Lato_700Bold,
//   Lato_400Regular,
//   LeagueSpartan_700Bold,
//   LeagueSpartan_300Light,
//   LeagueSpartan_500Medium,
//   LeagueSpartan_400Regular,
//   LeagueSpartan_600SemiBold,
// };
